import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';

class Integration extends Component {
    render() {
        return (
            <div className="gapresource-integration">
                <div className="gapresource-integration__wrapper">
                    <div className="gapresource-integration__inner">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                        >
                            <CommonUsualText className="gapresource-integration__text">
                                Внутренние страницы спроектировали с учётом объёма и типа
                                информации. Всего разработали 5 тематических блоков и 25 внутренних
                                страниц. В итоге сайт «закрывает» информационные потребности целевой
                                аудитории: потребителей, партнеров, сотрудников и инвесторов.
                            </CommonUsualText>
                        </ScrollAnimation>
                    </div>

                    <div className="gapresource-integration__container">
                        <img
                            className="gapresource-integration__img"
                            src="/images/pic/gapresource/intg2.jpg"
                            alt="pill"
                            loading="lazy"
                        />
                        <img
                            className="gapresource-integration__img"
                            src="/images/pic/gapresource/intg1.jpg"
                            alt="pill"
                            loading="lazy"
                        />
                        <img
                            className="gapresource-integration__img"
                            src="/images/pic/gapresource/intg3.jpg"
                            alt="pill"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Integration;
